import Dexie from 'dexie';
import syncstorage from './lib/syncstorage';

export const db = () => {
  const facilityId = syncstorage.getFacility();
  const db = new Dexie('awa_' + facilityId);
  db.version(19).stores({
    changes: 'id, sync', // Primary key and indexed props
    animals: 'id, sync',
    facility: 'id, sync',
    users: 'id, sync',
    assessments: 'id, animal_id, started_on, submitted_on, sync',
    assessment_types: 'id, facility_id, sync',
    section_b_behavior_tags: 'id, facility_id, species, behavior_key, sync',
    sectionb: 'id, assessment_id, observation_range, user_id, sync',
    sectionc: 'id, assessment_id, user_id, sync',
    sectiona: 'id, assessment_id, user_id, sync',
    sectioncioa: 'id, assessment_id, user_id, sync',
    finalevaluations: 'id,user_id,sync',
    locations: 'id, facility_id, sync',
  });
  return db;
};
/*
db.open().catch(function (e) {
    console.error("Open failed: " + e.stack);
})
*/
